export const castToArray = <T>(value: T | Array<T> | null | undefined): Array<T> =>
	Array.isArray(value) ? value : ([value].filter(Boolean) as any);
